import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const OuterContainer = styled.div`
	width: 100%;
	height: 100%;
	background-color: var(--white);
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 80vw;
	margin: 0 auto;
	margin-top: 1rem;
	margin-bottom: 2rem;
	@media ${Breakpoints.tablet} {
		width: 95%;
		margin: 0 15px !important;
	}
`;

export const Logo = styled(Image)`
	margin: 2rem 0;
	cursor: pointer;
`;

export const Footer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: max(80vw, 360px);
	margin: 0 auto;
	margin-top: auto;
	margin-bottom: 3rem;
	& > span {
		color: #747474 !important;
	}

	& > button > * {
		color: #747474 !important;
	}
`;

export const InputContainer = styled.div`
	display: flex;
	margin: 3rem 0;
	margin-left: 10vw;
	body[dir='rtl'] & {
		margin-left: 0;
		margin-right: 10vw;
		@media ${Breakpoints.tablet} {
			margin-left: 0;
			margin-right: 0;
		}
	}

	@media ${Breakpoints.tablet} {
		margin-left: 0;
		margin-right: 0;
	}

	& > div:nth-of-type(2) {
		margin-right: 0;
		body[dir='rtl'] & {
			margin-left: 0;
		}
		@media ${Breakpoints.tablet} {
			margin-right: 2rem;
			body[dir='rtl'] & {
				margin-right: 0;
				margin-left: 2rem;
			}
		}
	}

	& > div:nth-of-type(3) {
		margin-right: 2rem;
		body[dir='rtl'] & {
			margin-right: 0;
		}
		@media ${Breakpoints.tablet} {
			margin-right: 0;
		}
	}

	& > div:nth-of-type(3) > span {
		@media ${Breakpoints.tablet} {
			display: none;
		}
	}

	@media ${Breakpoints.tablet} {
		flex-direction: column;
		align-items: stretch;
		gap: 3rem;
	}
`;

export const TextInputContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-right: 2rem;
	body[dir='rtl'] & {
		margin-right: 0;
		margin-left: 2rem;
	}

	& > input {
		width: 300px;
		height: 50px;
		max-height: 50px;
		background-color: #f5f5f5;
		color: #000000;
		border: 1px solid var(--white);
		transition: all 0.3s ease-in-out;
		@media ${Breakpoints.tablet} {
			width: 100%;
		}
	}
	& > input:hover {
		box-shadow: none;
	}

	& > input:active {
		border: 1px solid var(--border-color);
		background-color: var(--white);
	}

	& > input:focus {
		border: 1px solid var(--border-color);
		background-color: var(--white);
		outline: none;
		box-shadow: none;
	}

	& > button {
		height: 50px;
		width: 120px;
		font-size: 15px;
		border-radius: 0 var(--small-border-radius) var(--small-border-radius) 0 !important;
		body[dir='rtl'] & {
			border-radius: var(--small-border-radius) 0 0 var(--small-border-radius) !important;
		}
		transition: none;
		@media ${Breakpoints.tablet} {
			width: 100%;
			border-radius: var(--small-border-radius) !important;
		}
	}

	@media ${Breakpoints.tablet} {
		margin-right: 0;
		margin-left: 0;
		width: 100%;
	}
`;

export const LeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	& > span {
		margin: 0 0 0 10vw;
		body[dir='rtl'] & {
			margin: 0 10vw 0 0;
			@media ${Breakpoints.tablet} {
				margin-left: 0;
				margin-right: 0;
			}
		}
		@media ${Breakpoints.tablet} {
			margin-left: 0;
			margin-right: 0;
		}
	}
`;

export const ErrorWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 4px;
`;

export const RightContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 70%;
	margin: 0 10vw 0 0;

	@media ${Breakpoints.tablet} {
		width: 0;
	}
`;

export const MiddleContainer = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	height: 60%;
	@media ${Breakpoints.tablet} {
		height: auto;
	}
	@media ${Breakpoints.tablet} {
		margin: 0 15px;
		width: calc(100% - 30px);
	}
`;

export const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	margin: 2rem 0 0 10vw;
	body[dir='rtl'] & {
		margin: 2rem 10vw 0 0;
		@media ${Breakpoints.tablet} {
			flex-wrap: wrap;
			justify-content: center;
			margin-right: 0;
		}
	}
	gap: 2.5rem;
	width: 100%;

	& > img:nth-of-type(2) {
		padding: 5px 0;
	}

	@media ${Breakpoints.tablet} {
		flex-wrap: wrap;
		justify-content: center;
		margin-left: 0;
	}
`;

export const ResultContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 4rem;
	gap: 2rem;
	width: 100%;
	background-color: #fafafa;
	padding: 48px 10vw;
	@media ${Breakpoints.tablet} {
		padding: 24px 5px;
	}
`;

export const ResultLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 2rem;
`;

export const ErrorContainer = styled.div`
	display: flex;
	align-items: center;
	background-color: var(--white);
	border-radius: 6px;
	padding: 3rem;
	width: 100%;
	height: 100px;
	gap: 2rem;
	border: 1px solid var(--border-color);
	transition: all 0.3s ease-in-out;

	& > div:nth-of-type(2) {
		width: fit-content;
	}
`;

export const Result = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: var(--white);
	border-radius: 6px;
	padding: 3rem;
	width: 100%;
	height: 100px;
	gap: 2rem;
	border: 1px solid var(--border-color);
	transition: all 0.3s ease-in-out;

	& > div:nth-of-type(2) {
		width: fit-content;
	}
`;

export const ResultClickable = styled(Result)`
	cursor: pointer;
	&:hover {
		box-shadow: var(--container-box-shadow);
	}
`;

export const GoButton = css`
	border-radius: 10px !important;
`;

export const HeaderCss = css`
	font-size: 35px !important;
	font-weight: 700;
`;

export const InputLabelCss = css`
	font-size: 15px !important;
	font-weight: 500 !important;
	margin-bottom: 10px;
`;
